<app-data-setup-common-content [isIos]="true" [isTmo]="false" [isGeneration]="true"></app-data-setup-common-content>
<div class="fifth-generation-container page-section">
    <div class="back-section">
        <a (click)="back()"><img src="assets/icon/primary-back-arrow.svg" width="20" height="20"
                alt="Back Arrow Icon">Back</a>
    </div>
    <div class="container-title">
        <img src="assets/icon/settings-icon.svg" width="24" height="24" alt="Settings Icon">
        <div class="content">
            <h5>iPhone 5G INSTRUCTIONS:</h5>
            <p class="version-title" *ngIf="!!isVersionSubmitted"><b>{{IosVersionsForm?.controls?.option?.value ===
                    'lower' ? 'iOS 16.6.1 version and LOWER': 'Version iOS 17'}}</b></p>
        </div>
    </div>
    <div class="select-version-part" *ngIf="!isVersionSubmitted">
        <p class="smaller" [class.alert-msg]="!!IosVersionsForm.touched && !!IosVersionsForm.invalid">Please select the
            iOS version on your iPhone:</p>
        <form [formGroup]="IosVersionsForm">
            <label for="lower">
                <input type="radio" value="lower" formControlName="option" id="lower">
                <p class="smaller">iOS 16.6.1 and LOWER</p>
            </label>
            <label for="higher">
                <input type="radio" value="higher" formControlName="option" id="higher">
                <p class="smaller">iOS 17</p>
            </label>
        </form>
        <button class="button primary" (click)="submitVersion()">Next</button>
    </div>
    <ng-container
        *ngIf="(IosVersionsForm?.controls?.option?.value === 'lower' && !!isVersionSubmitted) || !!isManuallyClicked">
        <div class="version-content">
            <ng-container *ngIf="!mdn">
                <p class="smaller">Please <b>download</b> the configuration file below on your FreeUpMobile device.*</p>
                <p class="smallest text"><b>*Recommendation:</b> Open this link directly on the mobile device you want
                    to set
                    up your data on.</p>
                <div class="download-file-part">
                    <p class="smaller"><b>iPhone 5G-eRESELLER APN FILE:</b></p>
                    <a href="assets/ereseller.mobileconfig">Download File<img
                            src="assets/icon/circle-down-arrow-icon.svg" width="20" height="20" alt="Arrow Icon"></a>
                </div>

            </ng-container>
            <ng-container *ngIf="!!mdn">
                <p class="smaller">By clicking the button below, 5G will be enabled and the configuration file will
                    start downloading automatically. It may prompt you to ‘install’ the file, *depending on the model of
                    your phone.</p>
                <p class="smallest text"><b>*Recommendation:</b> Open this link directly on the mobile device you want
                    to set
                    up your data on.</p>
                <p class="smaller button-title"><b>To enable 5G and download the file, click the button below:</b></p>
                <button class="button primary" aria-label="Enable 5G" (click)="enable5G()">Enable 5G</button>
            </ng-container>
            <div class="note-box">
                <div class="flex">
                    <img src="assets/icon/banner-info-icon.svg" width="24" height="24" class="info-icon"
                        alt="Info Icon">
                    <div class="content">
                        <p class="smaller">Some users may need to follow additional steps shown in this link. <b>Models:
                                X, Xs, Xr</b>.</p>
                        <a (click)="showLTEsettingPopUp()">How to Download Link<img
                                src="assets/icon/circle-down-arrow-icon.svg" width="20" height="20"
                                alt="Arrow Icon"></a>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="IosVersionsForm?.controls?.option?.value === 'higher' && !!isVersionSubmitted && !isManuallyClicked">
        <div class="version-content higher-version-content">
            <p class="smaller">With your FreeUp SIM installed, follow these steps on your iPhone:</p>
            <ul class="steps-part">
                <li>Go to <b>Settings</b></li>
                <li>Select <b>‘Cellular’</b></li>
                <li>Select <b>‘Cellular Data’</b></li>
                <li>Turn on <b>‘Use Carrier Settings’</b></li>
                <li class="last">You should see <b>green</b> as indicated in <b>Image 2</b> below:</li>
            </ul>
            <div class="carrier-settings-part">
                <div class="box">
                    <div class="box-row">
                        <p class="smallest"><b>Image 1:</b> Use Carrier Settings <b>OFF</b></p>
                        <img src="assets/img/disabled-carrier-setting-img.svg" width="288" height="65"
                            alt="Disabled Carrier Setting Image">
                    </div>
                    <div class="box-row">
                        <p class="smallest"><b>Image 2:</b> Use Carrier Settings <b>ON</b></p>
                        <img src="assets/img/enabled-carrier-setting-img.svg" width="288" height="65"
                            alt="Enabled Carrier Setting Image">
                    </div>
                </div>
            </div>
            <div class="view-tutorial-part">
                <a (click)="showIos17PopUp()">You can view the tutorial here<img
                        src="assets/icon/circle-right-arrow.svg" width="20" height="20" alt="Arrow Icon"></a>
            </div>
            <div class="info-banner default-background">
                <div class="flex">
                    <img src="assets/icon/banner-info-icon.svg" width="32" height="32" alt="Info Icon">
                    <div class="banner-content">
                        <h5 class="title">Phone not working after clicking ‘Use Carrier Settings’?</h5>
                        <p class="smaller desc-a">Once you enable <b>‘Use Carrier Settings’</b>, if your phone is not
                            working or reading “SOS”, <b>don’t worry</b>, we can help.</p>
                        <p class="smaller desc-b"><b>5G is required</b> to be able to use the services with ‘Use Carrier
                            Settings’ enabled. </p>
                        <p class="smaller desc-a last">You can add 5G to your line by clicking the <b>‘Add 5G’</b> link
                            below, or give us a <b>call</b> at <a
                                href="tel: {{CUSTOMER_CARE_NUMBER}}">{{CUSTOMER_CARE_NUMBER | phone}}</a> for live
                            assistance.</p>
                        <div class="actions">
                            <button class="button primary" (click)="goToAccountSummary()">Add 5G</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="last-section">
                <p class="smaller">Don’t {{!!isLoggedIn ? 'see those options' : 'want to log in'}}? <a
                        (click)="add5GManually()">Click Here</a> <b> to manually add 5G to your iPhone</b>.</p>
                <button class="button secondary" (click)="done()">Done</button>
            </div>
        </div>
    </ng-container>
</div>